export const highlight = {
  highlight: {
    background: 'var(--p-primary-50)',
    focusBackground: 'var(--p-primary-50)',
    color: '#495057',
    focusColor: '#495057',
  },
};
